module.exports = __webpack_public_path__ + "static/media/bsgdesign.a1caa3c0.png";